import React from "react";

export const User = (): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="true"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 18 18"
    >
      <path
        fillRule="evenodd"
        d="M5.25 5.25C5.25 3.15 6.9 1.5 9 1.5s3.75 1.65 3.75 3.75S11.1 9 9 9 5.25 7.35 5.25 5.25zm10.5 9v1.5c0 .45-.3.75-.75.75s-.75-.3-.75-.75v-1.5c0-1.275-.975-2.25-2.25-2.25H6c-1.275 0-2.25.975-2.25 2.25v1.5c0 .45-.3.75-.75.75s-.75-.3-.75-.75v-1.5c0-2.1 1.65-3.75 3.75-3.75h6c2.1 0 3.75 1.65 3.75 3.75zM9 7.5c-1.275 0-2.25-.975-2.25-2.25S7.725 3 9 3s2.25.975 2.25 2.25S10.275 7.5 9 7.5z"
        clipRule="evenodd"
      />
    </svg>
  );
};
